import ReactMarkdown from "react-markdown";

export function Markdown({ children }: { children: string }) {
  return (
    <div className="space-y-3 text-sm leading-relaxed text-foreground/80">
      <ReactMarkdown
        components={{
          h1: (p) => <h1 className="text-xl font-bold text-foreground" {...p} />,
          h2: (p) => (
            <h2 className="mt-4 text-lg font-semibold text-foreground" {...p} />
          ),
          h3: (p) => (
            <h3 className="mt-3 font-semibold text-foreground" {...p} />
          ),
          p: (p) => <p {...p} />,
          ul: (p) => <ul className="list-disc space-y-1 pl-5" {...p} />,
          ol: (p) => <ol className="list-decimal space-y-1 pl-5" {...p} />,
          li: (p) => <li {...p} />,
          strong: (p) => (
            <strong className="font-semibold text-foreground" {...p} />
          ),
          a: (p) => <a className="text-brand-600 underline" {...p} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
